"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPersonaliseScore = exports.analysis = exports.questions = void 0;

var _screeners = require("../../screeners");

var _utils = require("../../screeners/utils");

var surveyscreeners = [_utils.screeners.PERSONALISATION];
var questions = (0, _screeners.expandscreeners)([_utils.screeners.PERSONALISATION]);
exports.questions = questions;

var mapPersonaliseScore = function mapPersonaliseScore(interest, scores) {
  switch (interest) {
    case "Learn mental fitness skills":
      scores["retraining1"] += 10; // Mindset

      scores["pleasant"] += 9; // Personal values

      scores["letgo"] += 8; // Mindfulness

      scores["breathing"] += 7; // Stress management

      scores["awareness"] += 0; // Starting a conversation

      scores["crisis"] += 0;
      scores["earlyWarningSigns"] += 0;
      scores["revision"] += 0;
      scores["stress"] += 3;
      scores["guilt"] += 2;
      scores["metacognition"] += 1;
      scores["beliefs"] += 4;
      scores["reflectiveListening"] = 0;
      scores["sleep"] += 0;
      scores["control"] += 0;
      scores["observer"] += 0;
      scores["autopilot"] += 0;
      scores["threats"] += 0;
      scores["healthAndDiseaseAnxiety"] += 0;
      scores["perspectivetaking"] += 0;
      break;

    case "Build better habits":
      scores["retraining1"] += 0; // Mindset

      scores["pleasant"] += 0; // Personal values

      scores["letgo"] += 1; // Mindfulness

      scores["breathing"] += 0; // Stress management

      scores["awareness"] += 0; // Starting a conversation

      scores["crisis"] += 0;
      scores["earlyWarningSigns"] += 0;
      scores["revision"] += 0;
      scores["stress"] += 0;
      scores["guilt"] += 0;
      scores["metacognition"] += 0;
      scores["beliefs"] += 0;
      scores["reflectiveListening"] = 2;
      scores["sleep"] += 0;
      scores["control"] += 0;
      scores["observer"] += 0;
      scores["autopilot"] += 0;
      scores["threats"] += 0;
      scores["healthAndDiseaseAnxiety"] += 0;
      scores["perspectivetaking"] += 0;
      break;

    case "Change my beliefs":
      scores["retraining1"] += 10; // Mindset

      scores["pleasant"] += 0; // Personal values

      scores["letgo"] += 0; // Mindfulness

      scores["breathing"] += 0; // Stress management

      scores["awareness"] += 0; // Starting a conversation

      scores["crisis"] += 0;
      scores["earlyWarningSigns"] += 0;
      scores["revision"] += 0;
      scores["stress"] += 0;
      scores["guilt"] += 0;
      scores["metacognition"] += 0;
      scores["beliefs"] += 9;
      scores["reflectiveListening"] = 0;
      scores["sleep"] += 0;
      scores["control"] += 0;
      scores["observer"] += 0;
      scores["autopilot"] += 0;
      scores["threats"] += 0;
      scores["healthAndDiseaseAnxiety"] += 0;
      scores["perspectivetaking"] += 0;
      break;

    case "Mental health":
      scores["retraining1"] += 4; // Mindset

      scores["pleasant"] += 3; // Personal values

      scores["letgo"] += 2; // Mindfulness

      scores["breathing"] += 1; // Stress management

      scores["awareness"] += 0; // Starting a conversation

      scores["crisis"] += 0;
      scores["earlyWarningSigns"] += 0;
      scores["revision"] += 0;
      scores["stress"] += 0;
      scores["guilt"] += 0;
      scores["metacognition"] += 0;
      scores["beliefs"] += 0;
      scores["reflectiveListening"] = 0;
      scores["sleep"] += 0;
      scores["control"] += 0;
      scores["observer"] += 0;
      scores["autopilot"] += 0;
      scores["threats"] += 0;
      scores["healthAndDiseaseAnxiety"] += 0;
      scores["perspectivetaking"] += 0;
      break;

    case "Helping Others with Mental Health":
      scores["retraining1"] += 0; // Mindset

      scores["pleasant"] += 0; // Personal values

      scores["letgo"] += 0; // Mindfulness

      scores["breathing"] += 0; // Stress management

      scores["awareness"] += 6; // Starting a conversation

      scores["crisis"] += 7;
      scores["earlyWarningSigns"] += 5;
      scores["revision"] += 0;
      scores["stress"] += 0;
      scores["guilt"] += 0;
      scores["metacognition"] += 0;
      scores["beliefs"] += 0;
      scores["reflectiveListening"] = 8;
      scores["sleep"] += 0;
      scores["control"] += 0;
      scores["observer"] += 0;
      scores["autopilot"] += 0;
      scores["threats"] += 0;
      scores["healthAndDiseaseAnxiety"] += 0;
      scores["perspectivetaking"] += 0;
      break;

    case "Better sleep":
      scores["retraining1"] += 0; // Mindset

      scores["pleasant"] += 0; // Personal values

      scores["letgo"] += 7; // Mindfulness

      scores["breathing"] += 8; // Stress management

      scores["awareness"] += 0; // Starting a conversation

      scores["crisis"] += 0;
      scores["earlyWarningSigns"] += 0;
      scores["revision"] += 0;
      scores["stress"] += 1;
      scores["guilt"] += 2;
      scores["metacognition"] += 0;
      scores["beliefs"] += 0;
      scores["reflectiveListening"] = 0;
      scores["sleep"] += 0;
      scores["control"] += 6;
      scores["observer"] += 5;
      scores["autopilot"] += 4;
      scores["threats"] += 3;
      scores["healthAndDiseaseAnxiety"] += 0;
      scores["perspectivetaking"] += 0;
      break;

    case "Stress or Worry":
      scores["retraining1"] += 0; // Mindset

      scores["pleasant"] += 0; // Personal values

      scores["letgo"] += 0; // Mindfulness

      scores["breathing"] += 0; // Stress management

      scores["awareness"] += 0; // Starting a conversation

      scores["crisis"] += 0;
      scores["earlyWarningSigns"] += 0;
      scores["revision"] += 0;
      scores["stress"] += 2;
      scores["guilt"] += 1;
      scores["metacognition"] += 0;
      scores["beliefs"] += 0;
      scores["reflectiveListening"] = 0;
      scores["sleep"] += 0;
      scores["control"] += 0;
      scores["observer"] += 0;
      scores["autopilot"] += 0;
      scores["threats"] += 0;
      scores["healthAndDiseaseAnxiety"] += 0;
      scores["perspectivetaking"] += 0;
      break;

    case "Relationships":
      scores["retraining1"] += 0; // Mindset

      scores["pleasant"] += 0; // Personal values

      scores["letgo"] += 0; // Mindfulness

      scores["breathing"] += 0; // Stress management

      scores["awareness"] += 0; // Starting a conversation

      scores["crisis"] += 0;
      scores["earlyWarningSigns"] += 0;
      scores["revision"] += 0;
      scores["stress"] += 0;
      scores["guilt"] += 0;
      scores["metacognition"] += 0;
      scores["beliefs"] += 0;
      scores["reflectiveListening"] = 0;
      scores["sleep"] += 0;
      scores["control"] += 0;
      scores["observer"] += 0;
      scores["autopilot"] += 0;
      scores["threats"] += 0;
      scores["healthAndDiseaseAnxiety"] += 0;
      scores["perspectivetaking"] += 0;
      break;

    case "Health":
      scores["retraining1"] += 0; // Mindset

      scores["pleasant"] += 10; // Personal values

      scores["letgo"] += 0; // Mindfulness

      scores["breathing"] += 0; // Stress management

      scores["awareness"] += 0; // Starting a conversation

      scores["crisis"] += 0;
      scores["earlyWarningSigns"] += 0;
      scores["revision"] += 0;
      scores["stress"] += 0;
      scores["guilt"] += 0;
      scores["metacognition"] += 0;
      scores["beliefs"] += 0;
      scores["reflectiveListening"] = 0;
      scores["sleep"] += 0;
      scores["control"] += 0;
      scores["observer"] += 0;
      scores["autopilot"] += 0;
      scores["threats"] += 0;
      scores["healthAndDiseaseAnxiety"] += 0;
      scores["perspectivetaking"] += 0;
      break;

    case "Career":
      scores["retraining1"] += 0; // Mindset

      scores["pleasant"] += 0; // Personal values

      scores["letgo"] += 0; // Mindfulness

      scores["breathing"] += 0; // Stress management

      scores["awareness"] += 0; // Starting a conversation

      scores["crisis"] += 0;
      scores["earlyWarningSigns"] += 0;
      scores["revision"] += 0;
      scores["stress"] += 0;
      scores["guilt"] += 0;
      scores["metacognition"] += 0;
      scores["beliefs"] += 0;
      scores["reflectiveListening"] = 8;
      scores["sleep"] += 0;
      scores["control"] += 0;
      scores["observer"] += 0;
      scores["autopilot"] += 0;
      scores["threats"] += 0;
      scores["healthAndDiseaseAnxiety"] += 0;
      scores["perspectivetaking"] += 0;
      break;

    case "Alcohol, Gambling or Addictions":
      scores["retraining1"] += 0; // Mindset

      scores["pleasant"] += 0; // Personal values

      scores["letgo"] += 0; // Mindfulness

      scores["breathing"] += 0; // Stress management

      scores["awareness"] += 0; // Starting a conversation

      scores["crisis"] += 0;
      scores["earlyWarningSigns"] += 0;
      scores["revision"] += 0;
      scores["stress"] += 0;
      scores["guilt"] += 0;
      scores["metacognition"] += 0;
      scores["beliefs"] += 0;
      scores["reflectiveListening"] = 0;
      scores["sleep"] += 0;
      scores["control"] += 0;
      scores["observer"] += 0;
      scores["autopilot"] += 0;
      scores["threats"] += 0;
      scores["healthAndDiseaseAnxiety"] += 0;
      scores["perspectivetaking"] += 0;
      break;
  }

  return scores;
};

exports.mapPersonaliseScore = mapPersonaliseScore;

var analysis = function analysis(answers) {
  if (!answers) return null;
  var results = {};
  surveyscreeners.forEach(function (screener) {
    var filteredQuestions = questions.filter(function (question) {
      return question.batteryId === screener;
    });
    results[screener] = (0, _screeners.extractResults)(filteredQuestions, answers[screener], screener); // answer: {WHO5: Array, STRESS: Array}

    filteredQuestions.forEach(function (q, i) {
      if (!q.key) return;
      results[q.key] = q.eval(answers[screener][i]);
    });
  });
  return results;
};

exports.analysis = analysis;